
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".8","fill":"#282828"}},[_c('path',{attrs:{"d":"M7.333 0H2.444A2.444 2.444 0 000 2.444v4.89a2.444 2.444 0 002.444 2.444h4.89a2.444 2.444 0 002.444-2.445V2.444A2.444 2.444 0 007.333 0zM19.556 0h-4.889a2.444 2.444 0 00-2.444 2.444v4.89a2.444 2.444 0 002.444 2.444h4.889A2.444 2.444 0 0022 7.333V2.444A2.444 2.444 0 0019.556 0zM7.333 12.223H2.444A2.444 2.444 0 000 14.667v4.889A2.444 2.444 0 002.444 22h4.89a2.444 2.444 0 002.444-2.444v-4.889a2.444 2.444 0 00-2.445-2.444zM17.111 22a4.889 4.889 0 100-9.777 4.889 4.889 0 000 9.777z"}})])])
          )
        }
      }
    